import { HttpErrorResponse, HttpHandlerFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthApiService } from '@p2p/auth/api';
import { LS_TOKEN_KEY } from '@p2p/auth/domain';
import { LocalStorageService } from '@p2p/shared/utils';
import { catchError, Observable, throwError } from 'rxjs';

const publicUrlRegExp = /^(?:https?:\/\/)?[^/:]+(?::\d+)?\/public\/.*$/;

export function authTokenInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<any> {
    const localStorageService = inject(LocalStorageService);
    const authApiService = inject(AuthApiService);
    const router = inject(Router);

    if (publicUrlRegExp.test(req.url)) {
        return next(req);
    }

    const token = localStorageService.getItem(LS_TOKEN_KEY);

    if (!token) {
        return next(req);
    }

    const newReq = req.clone({
        headers: req.headers.append('Authorization', `Bearer ${token}`)
    });

    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.Unauthorized) {
                localStorageService.removeItem(LS_TOKEN_KEY);
                authApiService.logout(router.url);
            }

            return throwError(() => error);
        })
    );
}
